module.exports = __webpack_public_path__ + "static/split-lam-labels-d0d804ae4fcac3f512f0362664ae05c4.png";